import { Heading, HStack, Icon, VStack } from '@chakra-ui/react';
import { Box, Flex, Text } from '@chakra-ui/layout';
import { BiBath, BsHouseDoor, BsPerson, IoBedOutline, IoResize, FaDog } from 'react-icons/all';
import React from 'react';
import { ObjectBase } from '../../types/ObjectTypes';

export interface ObjectHighlightedBaseDataProps {
  baseData: ObjectBase;
}

export const ObjectHighlightedBaseData = (props: ObjectHighlightedBaseDataProps): JSX.Element => {
  const { baseData } = props;

  return (
    <>
      <VStack gridGap={4}>
        <Flex flexWrap={'wrap'} width={'100%'} gridGap={4} textAlign={'center'}>
          <Box flex={1} textAlign={'left'}>
            <HStack alignItems={'stretch'}>
              <Icon
                as={BsHouseDoor}
                color={'gray.500'}
                mr={2}
                bg={'gray.100'}
                w={10}
                h={'100%'}
                boxShadow={'base'}
                borderRadius={8}
                p={1}
              />
              <VStack alignItems={'flex-start'} spacing={0.5} flex={1}>
                <Heading color={'gray.500'} size={'xs'} fontWeight={'semibold'} lineHeight={1}>
                  Zimmer
                </Heading>
                <Text color={'gray.800'} fontSize={'2xl'} fontWeight={'semibold'} lineHeight={1}>
                  {baseData.numberOfRooms}
                </Text>
              </VStack>
            </HStack>
          </Box>
          <Box flex={1} textAlign={'left'}>
            <HStack alignItems={'stretch'}>
              <Icon
                as={IoResize}
                color={'gray.500'}
                mr={2}
                bg={'gray.100'}
                w={10}
                h={'100%'}
                boxShadow={'base'}
                borderRadius={8}
                p={1}
              />
              <VStack alignItems={'flex-start'} spacing={0.5} flex={1}>
                <Heading color={'gray.500'} size={'xs'} fontWeight={'semibold'} lineHeight={1}>
                  Größe
                </Heading>
                <Text color={'gray.800'} fontSize={'2xl'} fontWeight={'semibold'} lineHeight={1}>
                  {baseData.sizeQm} m&sup2;
                </Text>
              </VStack>
            </HStack>
          </Box>
        </Flex>
        <Flex flexWrap={'wrap'} width={'100%'} gridGap={4} textAlign={'center'}>
          <Box flex={1} textAlign={'left'}>
            <HStack alignItems={'stretch'}>
              <Icon
                as={IoBedOutline}
                color={'gray.500'}
                mr={2}
                bg={'gray.100'}
                w={10}
                h={'100%'}
                boxShadow={'base'}
                borderRadius={8}
                p={1}
              />
              <VStack alignItems={'flex-start'} spacing={0.5} flex={1}>
                <Heading color={'gray.500'} size={'xs'} fontWeight={'semibold'} lineHeight={1}>
                  Schlafzimmer
                </Heading>
                <Text color={'gray.800'} fontSize={'2xl'} fontWeight={'semibold'} lineHeight={1}>
                  {baseData.numberOfBedrooms}
                </Text>
              </VStack>
            </HStack>
          </Box>
          <Box flex={1} textAlign={'left'}>
            <HStack alignItems={'stretch'}>
              <Icon
                as={BiBath}
                color={'gray.500'}
                mr={2}
                bg={'gray.100'}
                w={10}
                h={'100%'}
                boxShadow={'base'}
                borderRadius={8}
                p={1}
              />
              <VStack alignItems={'flex-start'} spacing={0.5} flex={1}>
                <Heading color={'gray.500'} size={'xs'} fontWeight={'semibold'} lineHeight={1}>
                  Badezimmer
                </Heading>
                <Text color={'gray.800'} fontSize={'2xl'} fontWeight={'semibold'} lineHeight={1}>
                  {baseData.numberOfBathrooms}
                </Text>
              </VStack>
            </HStack>
          </Box>
        </Flex>
        <Flex flexWrap={'wrap'} width={'100%'} gridGap={4} textAlign={'center'}>
          <Box flex={1} textAlign={'left'}>
            <HStack alignItems={'stretch'}>
              <Icon
                as={BsPerson}
                color={'gray.500'}
                mr={2}
                bg={'gray.100'}
                w={10}
                h={'100%'}
                borderRadius={8}
                p={1}
              />
              <VStack alignItems={'flex-start'} spacing={0.5} flex={1}>
                <Heading color={'gray.500'} size={'xs'} fontWeight={'semibold'} lineHeight={1}>
                  Personen
                </Heading>
                <Text color={'gray.800'} fontSize={'2xl'} fontWeight={'semibold'} lineHeight={1}>
                  {baseData.maximumPersons}
                </Text>
              </VStack>
            </HStack>
          </Box>
          <Box flex={1} textAlign={'left'}>
            <HStack alignItems={'stretch'}>
              <Icon
                as={FaDog}
                color={baseData.numberOfPets > 0 ? 'gray.500' : 'gray.500'}
                mr={2}
                bg={baseData.numberOfPets > 0 ? 'gray.100' : 'gray.100'}
                w={10}
                h={'100%'}
                boxShadow={'base'}
                borderRadius={8}
                p={1}
              />
              <VStack alignItems={'flex-start'} spacing={0.5} flex={1}>
                <Heading color={'gray.500'} size={'xs'} fontWeight={'semibold'} lineHeight={1}>
                  Haustiere
                </Heading>
                <Text
                  color={baseData.numberOfPets > 0 ? 'gray.800' : 'red.400'}
                  fontSize={'2xl'}
                  fontWeight={'semibold'}
                  lineHeight={1}>
                  {baseData.numberOfPets > 0 ? 'Erlaubt' : 'Nein'}
                </Text>
              </VStack>
            </HStack>
          </Box>
        </Flex>
      </VStack>
    </>
  );
};
